export const TO_BE_INITIATED = 10
export const PENDING = 20
export const NOT_SETTLED = 30
export const SETTLED = 40
export const NP_NP = "NP - NP"
export const MISC = "MISC"
export const NIL = "NIL"
export const NETWORK_PROVIDER = 10
export const BUYER_APP = 20
export const SELLER_APP = 30
export const LOGISTICS_PROVIDER = 40
export const BUYER = 50
export const SELLER = 60
export const SETTLEMENT_AGENCY = 70
export const BANK = 80
export const INTER_PARTICIPANT = 10
export const COLLECTOR = 20
export const SELF = 30

export const libraryData = [
    {
        "Disabled": false,
        "Selected": false,
        "Text": "To be Initiated",
        "Description": "To be Initiated",
        "Value": TO_BE_INITIATED
    },
    {
        "Disabled": false,
        "Selected": false,
        "Text": "Pending",
        "Description": "Pending",
        "Value": PENDING
    },
    {
        "Disabled": false,
        "Selected": false,
        "Text": "Settled",
        "Description": "Settled",
        "Value": SETTLED
    },
    {
        "Disabled": false,
        "Selected": false,
        "Text": "Not Settled",
        "Description": "Not Settled",
        "Value": NOT_SETTLED
    }
]